import { configFetch as fetch } from '@laigu/utils';

export const getDownloadJobListApi = params => {
  return fetch({
    url: '/export/jobs',
    params
  });
};

export const cancelDownloadJobApi = id => {
  return fetch({
    url: `/export/jobs/${id}/cancel`,
    method: 'PUT'
  });
};
